import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/seo/index.js';
import { ErrorScreen } from '../components/shared/ErrorScreen.js';
import { useAuthStore } from '../store/authStore.js';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  return (
    <>
      <SEO noindex title={t('common.notFound.title', { defaultValue: 'Not found' })} description="The requested page could not be found." />
      <ErrorScreen
        code="404"
        bubble={t('errors.notFound.bubble', { defaultValue: 'Hmm… I looked everywhere and couldn’t find that page.' })}
        title={t('common.notFound.heading', { defaultValue: 'Page not found' })}
        message={t('errors.notFound.message', {
          defaultValue: 'The page you’re after may have moved, been renamed, or never existed. Let’s get you back on track.',
        })}
        actions={[
          {
            label: user ? t('nav.dashboard') : t('common.backHome', { defaultValue: 'Back home' }),
            onClick: () => navigate(user ? '/dashboard' : '/'),
            variant: 'primary',
            icon: user ? 'home' : 'arrow-left',
          },
          {
            label: t('common.notFound.contactSupport', { defaultValue: 'Contact support' }),
            onClick: () => navigate('/support'),
            variant: 'secondary',
            icon: 'message-circle',
          },
        ]}
      />
    </>
  );
}
